import type { FC } from 'react';

import { useAppContext } from '~/utilities/context/static/AppContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';

const FOREX_RATE_EUR_BGN = 1.95583;

type Props = {
  price: number;
};

export const ProductPriceSummaryForex: FC<Props> = ({ price }) => {
  const { country } = useAppContext();
  const { priceFormatter } = useStaticContext();

  if (country !== 'bg') {
    return null;
  }

  const finalPriceForexValue = price * FOREX_RATE_EUR_BGN;
  const formattedPrice = priceFormatter(finalPriceForexValue, 'BGN');

  return <> / {formattedPrice}</>;
};
